import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import { environment } from "../../environments/environment";
import { JobInvoice } from '../models/JobInvoice';


@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

    constructor(private http: HttpClient) { }


    public searchInvoice(searchTerm: string, page: number, pageSize: number, invoiceCodes?: string, startDate?: string, endDate?: string): Observable<any> {
        let dateParams = '';
        if (startDate) {
          dateParams += '&startDate=' + encodeURIComponent(startDate);
        }
        if (endDate) {
          dateParams += '&endDate=' + encodeURIComponent(endDate);
        }

        let qureyString : string;
        if (invoiceCodes != null && invoiceCodes.trim() != "") {
          qureyString = "/invoices/list?codes=" + encodeURIComponent(invoiceCodes) + "&page=" + page + "&size=" + pageSize + dateParams;
        } else if(searchTerm == null || searchTerm.trim()==""){
          qureyString = "/invoices/list?page="+ page + "&size="+pageSize + dateParams;
        }else{
          qureyString ='/invoices?searchTerm=' + encodeURIComponent(searchTerm) + '&page='+page+'&size='+pageSize + dateParams;
        } 
    
        return this.http.get<any>(environment.APIENDPOINT + qureyString, {
          headers: this.setHeaders(),
          responseType: 'json'
        });
      }




    public loadInvoice(JobId: string): Observable<any> {
        return this.http.get<any>(environment.APIENDPOINT + '/jobs/' + JobId + '/invoices', {
            headers: this.setHeaders(),
            responseType: 'json'
        });
    }


    public saveInvoice(invoice: JobInvoice) {
        return this.http.post(environment.APIENDPOINT + '/invoices', invoice,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );
    }

    public saveAndPostToAccountPlatform(invoice: JobInvoice, accountingPlatform: string, accountingTenant : string) {
        return this.http.post(environment.APIENDPOINT + '/invoices?accountingProvider=' + accountingPlatform + '&accountTenent=' + accountingTenant, invoice,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );
    }

    public getInvoiceList(): Observable<any> {
        return this.http.get<any>(environment.APIENDPOINT + '/invoices', {
            headers: this.setHeaders(),
            responseType: 'json'
        });
    }

    public getInvoiceListByPages(page: number, pageSize: number): Observable<any> {
        return this.http.get<any>(environment.APIENDPOINT + '/invoices/list?page=' + page + '&size=' + pageSize, {
            headers: this.setHeaders(),
            responseType: 'json'
        });
    }

    public getInvoiceItemTemplates(): Observable<any> {
        return this.http.get<any>(environment.APIENDPOINT + '/jobInvoiceItemTemplates', {
            headers: this.setHeaders(),
            responseType: 'json'
        });
    }

    public validateAccounting(): Observable<any> {
        return this.http.get<any>(environment.APIENDPOINT + '/accounting/validateAccounting', {
            headers: this.setHeaders(),
            responseType: 'json'
        });
    }

    public searchsInvoices(searchTerm: string): Observable<any> {
        return this.http.get<any>(environment.APIENDPOINT + '/invoices?searchTerm=' + searchTerm, {
            headers: this.setHeaders(),
            responseType: 'json'
        });
    }

    private setHeaders() {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let userTenant = localStorage.getItem('userTenant');
        let authHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + currentUser.token, 'X-Tenant': userTenant });
        return authHeader;
    }



}
